export default "__VITE_ASSET__CBUUG2dd__$_?url__"